import { useTheme } from "../ThemeContext";
import { fmt } from "../theme";

export const KpiCard = ({ label, value, color, delay = 0 }) => {
  const { theme: C } = useTheme();
  return (
  <div className="stat-card" style={{
    background: C.card, borderRadius: 16, padding: 20, border: `1px solid ${C.border}`,
    animation: `fadeUp .4s ease-out ${delay}s both`,
  }}>
    <div style={{ width: 8, height: 8, borderRadius: "50%", background: color, marginBottom: 16 }} />
    <div style={{ fontFamily: "'Plus Jakarta Sans'", fontWeight: 800, fontSize: 28, lineHeight: 1, marginBottom: 6 }}>{value}</div>
    <div style={{ fontSize: 13, color: C.textMuted }}>{label}</div>
  </div>
  );
};

export const DataTable = ({ headers, children }) => {
  const { theme: C } = useTheme();
  return (
  <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <thead>
      <tr>
        {headers.map(h => (
          <th key={h} style={{ textAlign: "left", padding: "10px 12px", fontSize: 11, fontWeight: 700, color: C.textMuted, textTransform: "uppercase", borderBottom: `1px solid ${C.border}` }}>{h}</th>
        ))}
      </tr>
    </thead>
    <tbody>{children}</tbody>
  </table>
  );
};

export const StatusBadge = ({ status, label, color, bg }) => (
  <span style={{ fontSize: 11, fontWeight: 700, color, background: bg, padding: "4px 10px", borderRadius: 6 }}>{label}</span>
);

export const Card = ({ children, style = {} }) => {
  const { theme: C } = useTheme();
  return (
  <div style={{ background: C.card, borderRadius: 16, padding: 20, border: `1px solid ${C.border}`, ...style }}>{children}</div>
  );
};

export const EmptyState = ({ text = "Sem dados" }) => {
  const { theme: C } = useTheme();
  return (
  <div style={{ textAlign: "center", padding: 40, color: C.textMuted }}>{text}</div>
  );
};

export const ChartTooltip = ({ active, payload, label }) => {
  const { theme: C } = useTheme();
  if (active && payload?.length) {
    return (
      <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 8, padding: "8px 12px" }}>
        <p style={{ color: C.textSoft, fontSize: 12, margin: 0 }}>{label}</p>
        <p style={{ color: C.text, fontSize: 14, fontWeight: 700, margin: "4px 0 0" }}>
          {typeof payload[0].value === "number" && payload[0].value > 100 ? fmt(payload[0].value) : payload[0].value}
        </p>
      </div>
    );
  }
  return null;
};
